export default __webpack_public_path__ + "static/media/Support---Main-page---final (1).ae86cbb8.png";